module.exports = __webpack_public_path__ + "img/coffee.fb71adb6.png";